export var MaintenanceRunSortField;
(function (MaintenanceRunSortField) {
    MaintenanceRunSortField["MAINTENANCE_RUN_SORT_FIELD_STARTED_AT"] = "startedAt";
    MaintenanceRunSortField["MAINTENANCE_RUN_SORT_FIELD_FINISHED_AT"] = "finishedAt";
})(MaintenanceRunSortField || (MaintenanceRunSortField = {}));
